import { render, staticRenderFns } from "./dictionaryAdd.vue?vue&type=template&id=bcc08ee0&scoped=true&"
import script from "./dictionaryAdd.vue?vue&type=script&lang=js&"
export * from "./dictionaryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc08ee0",
  null
  
)

export default component.exports